/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type { HealthService } from "./HealthService";
import { healthService } from "./HealthService";
import type { LiteappApiService } from "./LiteappApiService";
import { liteappApiService } from "./LiteappApiService";
import type { FullappApiService } from "./FullappApiService";
import { fullappApiService } from "./FullappApiService";
import type { V3Service } from "./V3Service";
import { v3Service } from "./V3Service";
export type Services = {
    health: HealthService;
    liteappApi: LiteappApiService;
    fullappApi: FullappApiService;
    v3: V3Service;
};
export const services = {
    health: healthService,
    liteappApi: liteappApiService,
    fullappApi: fullappApiService,
    v3: v3Service
} as const;
